import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AccountService } from '../../../../../../../services/account/account.service';
import { TaxRateService } from '../../../../../../../services/tax-rate/tax-rate.service';
import { TaxRate } from '../../../../../../../models/tax-rate';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../utils';

@Component({
  selector: 'app-edit-tax-rate-modal',
  templateUrl: './edit-tax-rate-modal.component.html',
  styleUrls: ['./edit-tax-rate-modal.component.css']
})
export class EditTaxRateModalComponent implements OnInit {

  @Input() taxRate: TaxRate;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public loadingSubmit = false;
  public errors: any = {};
  public errorMessage = '';

  public serverError: number = null;

  constructor(
    public accountService: AccountService,
    public activeModal: NgbActiveModal,
    public taxRateService: TaxRateService
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().is_organization_admin) {
      return;
    }
  }

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';
    this.errors = {};

    this.taxRateService
      .updateTaxRate(this.taxRate)
      .then(updatedTaxRate => {
        this.savedCallback({
          text: this.taxRate.name + ' saved successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to edit tax rates.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
